import React from 'react';
import './Landing.css';

type State = {
  url: string;
};

type Props = {
  handleUpload: (file: File) => void;
};

class Landing extends React.Component<Props, State> {
  state: State = {
    url: '',
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ url: event.target.value });
  };

  handleFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { handleUpload } = this.props;
    const file = event.target.files && event.target.files[0];

    if (file) {
      handleUpload(file);
    }
  };

  handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
  };

  handleUrlClick = () => {
    const { url } = this.state;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('url', url);
    window.location.search = searchParams.toString();
  };

  render() {
    const { url } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        <label className="landing" htmlFor="landingInput">
          <span className="landing__title">Please enter a bundle url</span>
          <div className="landing__form">
            <input
              className="landing__input"
              name="url"
              aria-label="url"
              id="landingInput"
              type="url"
              value={url}
              placeholder="e.g. https://my.cdn.com/bundle.js"
              onChange={this.handleChange}
            />
            <button className="landing__go" type="submit" onClick={this.handleUrlClick}>
              Go!
            </button>
          </div>
        </label>
        <label className="landing" htmlFor="landingFileInput">
          <span className="landing__title">or upload a js bundle</span>
          <div className="landing__form">
            <input
              className="landing__input_file"
              name="file"
              aria-label="file"
              id="landingFileInput"
              type="file"
              onChange={this.handleFileInputChange}
            />
          </div>
        </label>
      </form>
    );
  }
}

export default Landing;
